import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FileUploader extends Component {

	constructor() {
		super();
		this.input = null;
		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		const { onUpload, ...props } = this.props;
		return (
			<input
				{...props}
				type='file'
				ref={input => this.input = input}
				onChange={this.handleChange}
				style={{ display: 'none' }}
			/>
		);
	}

	openPicker() {
		this.input && this.input.click();
	}

	handleChange(event) {
		const { files } = event.currentTarget;
		this.props.onUpload(files);
		event.currentTarget.value = '';
	}

}

FileUploader.propTypes = {
	onUpload: PropTypes.func.isRequired
};

export default FileUploader;


// WEBPACK FOOTER //
// ./src/components/FileUploader/FileUploader.js